$(function(){
    (function () {
        var cta = $(".sticky-cta");
        var ctaMobile = $(".sticky-cta--mobile");

        $(window).on("scroll load resize", function () {
            if (window.matchMedia(`(max-width: 599px)`).matches) {
                var scrolledPast = $(window).scrollTop() - cta.offset().top > ctaMobile.outerHeight(true) * 4;
                scrolledPast ? ctaMobile.addClass("active") : ctaMobile.removeClass("active");
            } else {
                ctaMobile.removeClass("active");
            }
        });
    }());
});
